import { useEffectOnce } from '@hooks/useEffectOnce';
import useFormatter from '@hooks/useFormatter';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { useValueState } from '@hooks/useValueState';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { IProtocoloMovimentacao, useVendedorMovimentacaoService } from '@services/VendedorMovimentacaoService';
import React from 'react';
import { useParams } from 'react-router-dom';

export type ProtocoloMovimentacaoProps = {
}

export interface IProtocoloMovimentacaoParams {
    id: string
}

export function ProtocoloMovimentacao (props: ProtocoloMovimentacaoProps) {
    const formatter = useFormatter();
    const protocoloMovimentacao = useValueState<IProtocoloMovimentacao>();
    
    const cls = useStyles();

    const params = useParams<IProtocoloMovimentacaoParams>();
    const vendedorMovimentacaoService = useVendedorMovimentacaoService();

    const loading = useLoading();
    const message = useMessage();

    useEffectOnce(() => {
        if (!loading.isLoading) {
            loading.start();
            vendedorMovimentacaoService.obterProtocolo(parseInt(params.id))
                .then(protocoloMovimentacao.handleResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    })

    return loading.isLoading
        ? <CircularProgress size="small" />
        : (
            <div className={cls.box}>
                <div className={cls.title}>Protocolo de Movimentação - {protocoloMovimentacao.value?.nomeTipo}</div>
                <div className={cls.value}>
                    <div>Nº {(protocoloMovimentacao.value?.id ?? 0) + 1}</div>
                </div>

                <table className={cls.reference}>
                    <tbody>
                        <tr>
                            <td className={cls.referenceTitle}>Atendente: </td>
                            <td>{protocoloMovimentacao.value?.atendente}</td>
                        </tr>

                        <tr>
                            <td className={cls.referenceTitle}>Vendedor: </td>
                            <td>{protocoloMovimentacao.value?.vendedor}</td>
                        </tr>

                        <tr>
                            <td className={cls.referenceTitle}>Telefone de Contato: </td>
                            <td>{protocoloMovimentacao.value?.telefoneVendedor}</td>
                        </tr>
                    </tbody>
                </table>

                <table className={cls.items}>
                    <thead>
                        <tr>
                            <th className={cls.itemsTitle}>Item</th>
                            <th className={cls.itemsTitle}>Linha</th>
                            <th className={cls.itemsTitle}>Empresa</th>
                            <th className={cls.itemsTitle}>Nº Contrato</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            protocoloMovimentacao.value?.itens.map((item, index) => (
                                <tr>
                                    <td className={cls.item}>{index + 1}</td>
                                    <td className={cls.item}>{formatter.toCelular(item.numeroLinha)}</td>
                                    <td className={cls.item}>{item.nomeEmpresa}</td>
                                    <td className={cls.item}>{item.numeroContrato}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>

                <div className={cls.date}>
                    <div className={cls.dateBox}>Barbacena, {protocoloMovimentacao.value?.dia} de {protocoloMovimentacao.value?.mesExtenso} de {protocoloMovimentacao.value?.ano}</div>
                </div>

                <div className={cls.sign}>
                    <div className={cls.signBox}>Assinatura</div>
                </div>
            </div>
        )
}

const useStyles = makeStyles(theme => ({
    box: {
        padding: 20,
        border: '1px solid #ccc',
        margin: 'auto',
        marginTop: 50
    },

    title: {
        fontSize: '1.2em',
        fontWeight: 'bold',
        textAlign: 'center'
    },

    value: {
        marginTop: 16,
        fontSize: '1.5em',
        fontWeight: 'bold',
        textAlign: 'center'
    },

    valueBox: {
        border: '2px solid #000',
        padding: 5,
    },

    body: {
    },

    date: {
        marginTop: 25,
        marginBottom: 40,
        display: 'flex',
        justifyContent: 'flex-end',
    },

    dateBox: {
    },

    reference: {
        marginTop: 16
    },

    referenceTitle: {
        textAlign: 'right',
        fontWeight: 'bold'
    },

    items: {
        marginTop: 16,
        width: '100%',
        padding: 8,
        border: '1px solid',
        borderCollapse: 'collapse'
    },

    itemsTitle: {
        textAlign: 'left',
        border: '1px solid',
        padding: 8
    },

    item: {
        textAlign: 'left',
        border: '1px solid',
        padding: 8
    },

    sign: {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center'
    },

    signBox: {
        width: 300,
        paddingTop: 5,
        borderTop: '1px solid #000'
    }
}));